
import { TemplateStyle } from './types';

export const companyName = "شركة السياحة الرائدة";

export const initialSections = [
    { id: 'client', name: 'معلومات العميل' },
    { id: 'hotels', name: 'الفنادق' },
    { id: 'flights', name: 'الطيران' },
    { id: 'tours', name: 'الجولات' },
    { id: 'price', name: 'السعر' },
    { id: 'notes', name: 'ملاحظات' },
    { id: 'terms', name: 'الشروط والأحكام' },
    { id: 'itinerary', name: 'جدول الرحلة' },
    { id: 'contact', name: 'معلومات التواصل' },
    { id: 'offers', name: 'عروض خاصة' },
    { id: 'transport', name: 'النقل والمواصلات' },
    { id: 'citiesPlan', name: 'خطة المدن' },
    { id: 'services', name: 'خدمات إضافية' },
    { id: 'inclusions', name: 'ما يشمله العرض' },
    { id: 'exclusions', name: 'ما لا يشمله العرض' },
];

const defaultTypography = { titleSize: 18, textSize: 13, fontWeight: 600, lineHeight: 1.6 };
const defaultSpacing = { pageMarginTop: 30, pageMarginRight: 35, pageMarginBottom: 30, pageMarginLeft: 35, sectionGap: 25, sectionPadding: 20 };
const defaultBorders = { width: 1, radius: 16, style: 'solid' as const };
const defaultHeader = { showCover: true, coverHeight: 400 };
const defaultFooter = { showFooter: true, showQr: true, showPageNumber: true, customText: '' };
const defaultWatermark = { text: '', opacity: 0.08, size: 60, rotation: -35 };

const makeTemplate = (colors: { [key: string]: string }, sections = [...initialSections]): TemplateStyle => ({
    colors,
    columns: [{ id: 'main', sections }],
    layoutGridCols: 1,
    media: {},
    typography: { ...defaultTypography },
    spacing: { ...defaultSpacing },
    borders: { ...defaultBorders },
    header: { ...defaultHeader },
    footer: { ...defaultFooter },
    watermark: { ...defaultWatermark },
    sectionStyles: {},
});

export const defaultSettings: { [key: string]: TemplateStyle } = {
  template1: makeTemplate({ primary: '#667eea', text: '#ffffff', background: '#f8f9fa' }),
  template2: makeTemplate({ primary: '#007bff', text: '#333333', background: '#f9f9f9' }),
  template3: makeTemplate({ primary: '#c4a75c', text: '#f0f0f0', background: '#383838' }),
  template4: makeTemplate({ primary: '#0891b2', text: '#f8fafc', background: '#1e293b' }),
  template5: makeTemplate({ primary: '#881337', text: '#1f2937', background: '#fefce8' }),
  template6: makeTemplate({ primary: '#7c3aed', text: '#111827', background: '#f3f4f6' }),
  template7: makeTemplate(
    { primary: '#1a1a2e', secondary: '#16213e', accent: '#d4a853', text: '#f0e6d3', background: '#0f0f23' },
    [
      ...initialSections.filter(s => !['transport'].includes(s.id)),
      { id: 'citiesPlan', name: 'خطة المدن' },
      { id: 'services', name: 'خدمات إضافية' },
      { id: 'inclusions', name: 'ما يشمله العرض' },
      { id: 'exclusions', name: 'ما لا يشمله العرض' },
    ]
  ),
};

export const getDefaultSettingsForTemplate = (templateId: string): TemplateStyle => {
  return defaultSettings[templateId] || defaultSettings.template1;
};
